export default "__VITE_ASSET__lvBCKK6o__"